<div class="card-container">
    <div *ngFor="let card of cardData" class="card-wrapper">
      <div class="card-title">{{ card.title }}</div>
      <div class="card-content" [innerHTML]="card.content"></div>
    </div>
  </div>
  